import * as constants from '../config/constants';

const getCSS = () => {
  let overrideCSS = null;
  if (window.location.host === constants.WWW_LMP_LAGNASETU_HOST) {
    overrideCSS = Object.assign(require('./main.css'), require('./mainCustom.css')); // eslint-disable-line
  }
  if (window.location.host === constants.MAIN_SITE_HOST) {
    // overrideCSS = require('./main.css');  // eslint-disable-line
    overrideCSS = Object.assign(require('./main.css'), require('./mainCustom.css')); // eslint-disable-line
  }
  if (window.location.host === constants.MUMBAI_SITE_HOST || window.location.host === constants.EASTINDIA_SITE_HOST ||
      window.location.host === constants.SOUTHGUJARAT_SITE_HOST || window.location.host === constants.SOUTHINDIA_SITE_HOST ||
      window.location.host === constants.CENTRALGUJARAT1_SITE_HOST || window.location.host === constants.CANADA_SITE_HOST ||
      window.location.host === constants.MIDDLE_EAST_SITE_HOST || window.location.host === constants.TANZANIA_SITE_HOST ||
      window.location.host === constants.USA_SITE_HOST) {
    overrideCSS = Object.assign(require('./main.css'), require('./mainMumbai.css')); // eslint-disable-line
  }
  if (window.location.host === constants.SAURASHTRA1_SITE_HOST || window.location.host === constants.SAURASHTRA2_SITE_HOST  ||
      window.location.host === constants.SAURASHTRA4_SITE_HOST || window.location.host === constants.NORTHGUJARAT_SITE_HOST ||
      window.location.host === constants.AFRICA_SITE_HOST) {
    overrideCSS = Object.assign(require('./main.css'), require('./mainSaurashtra1.css')); // eslint-disable-line
  }
  if (window.location.host === constants.KUTCH_HOST || window.location.host === constants.SAURASHTRA3_SITE_HOST ||
      window.location.host === constants.NORTHINDIA_SITE_HOST || window.location.host === constants.CENTRAL_INDIA_SITE_HOST ||
      window.location.host === constants.VIDARBHA_SITE_HOST || window.location.host === constants.UGANDA_SITE_HOST ||
      window.location.host === constants.AUSTRALIA_SITE_HOST || window.location.host === constants.CENTRALGUJARAT2_SITE_HOST) {
    overrideCSS = Object.assign(require('./main.css'), require('./mainKutch.css')); // eslint-disable-line
  }
  if (window.location.host === constants.MAHARASHTRA_SITE_HOST || window.location.host === constants.KENYA_SITE_HOST ||
      window.location.host === constants.EUROPE_SITE_HOST || window.location.host === constants.NZFIJI_SITE_HOST) {
    overrideCSS = Object.assign(require('./main.css'), require('./mainCentralGujarat.css')); // eslint-disable-line
  }

  if (window.location.host === constants.LOHANA_SITE_HOST) {
    overrideCSS = require('./theme2.css');  // eslint-disable-line
  }
  if (window.location.host === constants.DIVORCEE_SITE_HOST) {
    overrideCSS = require('./main.css');  // eslint-disable-line
  }
  if (window.location.host === constants.NRI_SITE_HOST) {
    overrideCSS = require('./theme3.css');  // eslint-disable-line
  }
  if (window.location.host === constants.JAIN_SITE_HOST) {
    overrideCSS = require('./theme2.css');  // eslint-disable-line
  }
  if (window.location.host === constants.GORMAHARAJ_HOST) {
    overrideCSS = require('./theme3.css');  // eslint-disable-line
  }
  if (window.location.host === constants.SHAADIYOG_HOST) {
    overrideCSS = require('./theme2.css');  // eslint-disable-line
  }
  return overrideCSS;
};

const cssClasses = getCSS();

export default cssClasses;



// WEBPACK FOOTER //
// ./src/css/getCSS.js